import React, { useEffect, useState } from "react";
import styled from "styled-components"
import { useParams } from "react-router-dom";

import Layout from "../components/layout"
import Container from "../components/container"
import ShowListing from "../components/shows-listing"

import { getShowByName } from "../shows"

import ReactGA from "react-ga4";
ReactGA.initialize("G-THHYTX4Y9V");

function ShowPage(props) {
  let { name } = useParams();
    
  const [show, setShow] = useState({});

  useEffect(() => {
    setShow(getShowByName(name));
  
    ReactGA.send({ hitType: "pageview", page: show.url, title: show.title});
  }, [name]);

  return (
    <Layout page="show" title={show.title}>    
      <Container>
        {show.template && <show.template show={show} />}

        <br />
        <br />

        <ShowListing show={show} />

        <br />
        <br />
        <br />
        <br />     
      </Container>
    </Layout>
  );
}

export default ShowPage;